var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3784 0 0.0107422 5.37281 0.0107422 12C0.0107422 18.6272 5.3784 24 12 24C18.6215 24 23.9892 18.6272 23.9892 12C23.9892 5.37281 18.6215 0 12 0ZM12 22.6561C6.11996 22.6561 1.35324 17.8852 1.35324 12C1.35324 6.11484 6.1209 1.34672 12 1.34391C17.879 1.34109 22.6467 6.11484 22.6467 12C22.6467 17.8852 17.88 22.6561 12 22.6561Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9272 11.3278H20.0569V12.6717H21.9272V11.3278Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94307 11.3278H2.07275V12.6717H3.94307V11.3278Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6718 20.0639H11.3289V21.9361H12.6718V20.0639Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2274 6.86391L12.2399 8.9761V5.3761H11.5682V9.2161L9.794 10.0781L9.12229 11.662H5.18994V12.3342H8.83494L6.62854 17.52L11.6165 15.36V18.96H12.2878V15.12L14.0624 14.3522L14.9259 12.3834H18.6665V11.6639H15.1649L17.2274 6.86391ZM8.0676 16.0313L10.4174 10.6552L13.4868 13.7269L8.0676 16.0313Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6235 2.0639H11.2805V3.93609H12.6235V2.0639Z",
    fill: "current",
    stroke: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_2219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.66d3141669d9c12b8c8780d068f727a5.svg";
export { ForwardRef as ReactComponent };